export const GET_JOBS = 'jobs/GET_JOBS'
export const GET_JOB = 'jobs/GET_JOB'
export const ADD_JOBS = 'jobs/ADD_JOBS'
export const EDIT_JOBS = 'jobs/EDIT_JOBS'
export const DELETE_JOBS = 'jobs/DELETE_JOBS'